import { render } from "./DynamicPage.vue?vue&type=template&id=b2f0376c&ts=true"
import script from "./DynamicPage.vue?vue&type=script&lang=ts"
export * from "./DynamicPage.vue?vue&type=script&lang=ts"

import "./DynamicPage.vue?vue&type=style&index=0&id=b2f0376c&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__